import {Component} from '@angular/core';

import {AppAlertService, SubtitlesService} from "../../../core";

@Component({
    selector: 'policy-pl',
    templateUrl: './policy-pl.component.html',
    styleUrls: ['./policy-pl.component.scss']
})
export class PolicyPlComponent {
    constructor(
        public appAlert: AppAlertService,
        public subtitles: SubtitlesService,
    ) {
    }
}
